import React from 'react';

import { useFormContext } from 'react-hook-form';

import { DateRangeFilter } from 'components/common/CustomFilters/DateRangeFilter/DateRangeFilter';
import { TabOptions } from 'components/common/CustomFilters/DateRangeFilter/DateRangeFilter.utils';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import { getInputValue } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.utils';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';

export const BaselineStartDate = ({ isSelected, onFiltersChanged }) => {
    const { watch } = useFormContext<IFields>();
    const handleBaselineStartDateSelection = (data: { value?: string[] | string; type?: TabOptions }) => {
        if (data.type === 'FIXED_DATE') {
            const tempFlags = watch('flags');
            delete tempFlags.baselineStartDatesRange;
            onFiltersChanged({
                baselineStartDate: {
                    value: Array.isArray(data.value) ? data.value.map(String) : [],
                    type: data.type,
                },
                flags: tempFlags,
            });
        } else {
            onFiltersChanged({
                baselineStartDate: { value: [], type: data.type },
                flags: {
                    ...watch('flags'),
                    baselineStartDatesRange: data.value as string,
                },
            });
        }
    };

    const baselineStartDateExistingData = {
        type: watch('baselineStartDate').type,
        value:
            watch('baselineStartDate').value.length === 0
                ? watch('flags').baselineStartDatesRange
                : watch('baselineStartDate').value,
    };

    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Baseline Start Date</span>
            <DateRangeFilter
                onChange={handleBaselineStartDateSelection}
                value={baselineStartDateExistingData}
                inputDefaultValue={getInputValue(baselineStartDateExistingData)}
            />
        </div>
    ) : null;
};
